// extracted by mini-css-extract-plugin
export default {"scroll":"scroll-IT9j"};